import dayjs from "dayjs";
import IconChevron from "@/assets/icons/chevron.svg?react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

interface Props {
    id: number;
    title: string;
    img: string;
    date: string;
    button?: string;
    description: string;
}

const NotificationCard = ({id, title, img, date, button, description}: Props) => {
    return (
        <div
            key={id}
            className={`w-full bg-white/08 gap-3 border-b border-b-white/08 self-stretch rounded-xl ${
                button ? "pb-0 pt-4" : img ? "pt-0" : "pt-4"
            }`}
        >
            {img && (
                <img
                    className="w-full aspect-[343/204] mb-3 h-auto overflow-hidden rounded-t-xl object-cover"
                    src={img}
                    alt={title}
                />
            )}
            <div className="px-3">
                <div className="flex mb-2 justify-between items-start">
                    <p className="text-xs font-normal leading-normal text-white">
                        {dayjs(date).format("D MMMM YYYY")}
                    </p>
                    <p className="text-xs font-normal leading-normal text-white">{dayjs(date).format("HH:mm")}</p>
                </div>
                <h1 className="overflow-ellipsis text-start font-semibold leading-120 mb-3 overflow-hidden">
                    {title}
                </h1>
                <p className={`leading-130 text-xs text-white overflow-ellipsis ${button ? "mb-3" : "mb-4"}`}>
                    {description}
                </p>
            </div>
            {button && (
                <VibratingButton
                    className="w-full bg-blue flex text-[13px] justify-between rounded-b-xl rounded-t items-center px-3 py-2.5">
                    {button}
                    <IconChevron width="20" height="20" className="text-white" strokeWidth="1.6"/>
                </VibratingButton>
            )}
        </div>
    );
};

export default NotificationCard;
